var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVncIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-round-airplay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nubis",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-Detail",
    transform: "translate(-308.000000, -182.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(307.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-round-airplay",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    fill: "#18ACC3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41,22 L15.58,22 C16.47,22 16.92,20.92 16.29,20.29 L12.7,16.7 C12.5131554,16.5127719 12.2595095,16.407556 11.995,16.407556 C11.7304905,16.407556 11.4768446,16.5127719 11.29,16.7 L7.7,20.29 C7.08,20.92 7.52,22 8.41,22 Z M21,3 L3,3 C1.9,3 1,3.9 1,5 L1,17 C1,18.1 1.9,19 3,19 L6,19 C6.55,19 7,18.55 7,18 C7,17.45 6.55,17 6,17 L4,17 C3.45,17 3,16.55 3,16 L3,6 C3,5.45 3.45,5 4,5 L20,5 C20.55,5 21,5.45 21,6 L21,16 C21,16.55 20.55,17 20,17 L18,17 C17.45,17 17,17.45 17,18 C17,18.55 17.45,19 18,19 L21,19 C22.1,19 23,18.1 23,17 L23,5 C23,3.9 22.1,3 21,3 Z",
    id: "Icon-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(5.000000, 8.000000)",
    fill: "#18ACC3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3425,5.9675 C3.64875,6.27375 4.13,6.3 4.48,6.055 C5.18875,5.5475 6.06375,5.25 7,5.25 C7.93625,5.25 8.81125,5.5475 9.52,6.04625 C9.87,6.29125 10.35125,6.27375 10.6575,5.9675 C11.03375,5.59125 10.99875,4.97 10.57875,4.655 C9.5725,3.92875 8.33875,3.5 7,3.5 C5.66125,3.5 4.4275,3.92875 3.42125,4.655 C2.9925,4.96125 2.96625,5.59125 3.3425,5.9675 Z M7,0 C4.69,0 2.5725,0.81375 0.91875,2.16125 C0.51625,2.49375 0.48125,3.0975 0.84875,3.465 C1.16375,3.78 1.6625,3.80625 2.00375,3.52625 C3.36,2.42375 5.10125,1.75 7,1.75 C8.89875,1.75 10.64,2.42375 11.9875,3.535 C12.32875,3.815 12.8275,3.78875 13.1425,3.47375 C13.51,3.10625 13.475,2.5025 13.0725,2.17 C11.4275,0.81375 9.31,0 7,0 Z",
    id: "Icon-Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVncIcon);
export default __webpack_public_path__ + "static/media/vnc-icon.d453f6dc1fe563cde2b39b69f51896e0.svg";
export { ForwardRef as ReactComponent };